import React, { useState, useEffect } from 'react';
import './navbar.css';
import { Link as RouterLink } from 'react-router-dom'
import ntu from '../../../assets/ntu2.png';
import { getLoginId, getToken } from '../../Authentication/AuthSvc/authservice';
import { checkAdminStatus } from '../../Authentication/AuthSvc/authservice';
import { jwtDecode } from "jwt-decode";

const Navbar = ({ loginstate, setLoginState }) => {
    const [showMenu, setShowMenu] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [username, setUsername] = useState('');
    const [hasAdminRole, setHasAdminRole] = useState(false); // Any admin role status
    const [userId, setUserId] = useState(null);

    const handleSearchButtonClick = () => {
        setShowSearch(!showSearch);
    };
    const toggleMenu = () => {
        setShowMenu(!showMenu);
    };
    const closeMenu = () => {
        setShowMenu(false);
    };

    useEffect(() => {
        const token = getToken();
        if (token) {
            const decodedToken = jwtDecode(token);

            setLoginState({
                isLoggedIn: true,
                loginId: decodedToken.userid
            });
            setUserId(decodedToken.userid);
            setHasAdminRole(decodedToken.hasAdminRole);
            const storedUsername = localStorage.getItem('username');
            setUsername(storedUsername);
        }
    }, [loginstate.isLoggedIn])

    return (
        <nav className="navbar">
            <RouterLink to='/'>
                <img src={ntu} alt="logo" className='logo' />
            </RouterLink>
            <div className='desktopMenu'>
                <div className='dropdown'>
                    <div className='desktopMenuBtn'>
                        Explore
                        <i className='fas fa-caret-down arrow-icon' />
                    </div>
                    <div className="dropdown-content">
                        <RouterLink to="/projectlist" className="dropdown-item">
                            Projects
                        </RouterLink>
                        <RouterLink to="/userlist" className="dropdown-item">
                            Users
                        </RouterLink>
                    </div>
                </div>
                <RouterLink to='/startproject' className='desktopMenuListItem'>Start a Project</RouterLink>
                <RouterLink to='/about' className='desktopMenuListItem'>
                    About Us
                </RouterLink>
            </div>
            <div className='desktopMenuBtns'>
                <div className='searchmain'>
                    <button className='desktopMenuBtn' onClick={handleSearchButtonClick}>
                        <i className="fa-solid fa-magnifying-glass desktopMenuImg"></i>
                    </button>
                    <div className="search-content">
                        {showSearch && (
                            <div className="search">
                                <input type="text" className='searchText' placeholder="Search..." />
                                <i className="fa-solid fa-x x-icon" onClick={handleSearchButtonClick}></i>
                            </div>
                        )}
                    </div>
                </div>

                <div className='dropdown'>
                    <button className='desktopMenuBtn'>
                        <i className='fa-regular fa-user desktopMenuImg'></i>
                        <div className='userName'>
                            {username}
                        </div>
                    </button>
                    <div className="dropdown-content2">
                        {loginstate.isLoggedIn ? (
                            <div>
                                <RouterLink to={`/myprofile/${userId}`} className="dropdown-item item-loggedin">
                                    My Profile
                                </RouterLink>
                                <RouterLink to={`/myprojects/${userId}`} className="dropdown-item item-loggedin">
                                    My Projects
                                </RouterLink>
                                <RouterLink to="/inbox" className="dropdown-item item-loggedin">
                                    Inbox
                                </RouterLink>
                                <RouterLink to="/chat" className="dropdown-item item-loggedin">
                                    Chat
                                </RouterLink>

                                {/* Show Dashboard link for any user with admin role */}
                                {loginstate.isLoggedIn && hasAdminRole && (
                                    <>
                                    <RouterLink to="/dashboard" className="dropdown-item item-loggedin">
                                        Dashboard
                                    </RouterLink>
                                    <RouterLink to="/admin" className="dropdown-item item-loggedin">
                                        Admin
                                    </RouterLink>
                                    </>
                                )}
                                <RouterLink to="/logout" className="dropdown-item item-loggedin">
                                    Log Out
                                </RouterLink>
                            </div>
                        ) : (
                            <div>
                                <RouterLink to="/signup" className="dropdown-item item-loggedout">
                                    Sign Up
                                </RouterLink>
                                <RouterLink to="/login" className="dropdown-item item-loggedout">
                                    Login
                                </RouterLink>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="hamburger-icon" onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
            {/* Mobile menu for responsive layout*/}

            <div className={`navMenu ${showMenu ? 'show' : ''}`}>
                {loginstate.isLoggedIn ? (
                    <>
                        <RouterLink to={`/myprofile/${userId}`} className='ListItem' onClick={closeMenu}>My Profile</RouterLink>
                        <RouterLink to={`/myprojects/${userId}`} className='ListItem' onClick={closeMenu}>My Projects</RouterLink>
                        <RouterLink to="/inbox" className='ListItem' onClick={closeMenu}>Inbox</RouterLink>
                        <RouterLink to="/chat" className='ListItem' onClick={closeMenu}>Chat</RouterLink>

                        {/* Add Dashboard and Admin links to mobile menu too */}
                        {hasAdminRole && (
                            <>
                            <RouterLink to="/dashboard" className='ListItem' onClick={closeMenu}>Dashboard</RouterLink>
                            <RouterLink to="/admin" className='ListItem' onClick={closeMenu}>Admin</RouterLink>
                            </>
                        )}

                        <RouterLink to="/logout" className='ListItem' onClick={closeMenu}>Log Out</RouterLink>
                    </>
                ) : (
                    <>
                        <RouterLink to="/signup" className='ListItem' onClick={closeMenu}>Sign Up</RouterLink>
                        <RouterLink to="/login" className='ListItem' onClick={closeMenu}>Login</RouterLink>
                    </>
                )}

                <RouterLink to="/" className='ListItem' onClick={closeMenu}>Home</RouterLink>
                <RouterLink to="/projectlist" className='ListItem' onClick={closeMenu}>Projects</RouterLink>
                <RouterLink to="/userlist" className='ListItem' onClick={closeMenu}>Users</RouterLink>
                <RouterLink to="/startproject" className='ListItem' onClick={closeMenu}>Start a Project</RouterLink>
                <RouterLink to="/about" className='ListItem' onClick={closeMenu}>About Us</RouterLink>
            </div>
        </nav>
    )
}

export default Navbar